module.exports = __webpack_public_path__ + "static/img/flowered-2.80106ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/xl/flowered-2.jpg
// module id = glvh
// module chunks = 1